import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "code",
  class: "label-text required"
}, "Nama Penjadwalan", -1)
const _hoisted_3 = { class: "invalid-feedback" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "start-date",
  class: "label-text required"
}, "Tanggal Awal", -1)
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "end-date",
  class: "label-text required"
}, "Tanggal Akhir", -1)
const _hoisted_8 = { class: "invalid-feedback" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "conductor",
  class: "label-text"
}, "Kondektur", -1)
const _hoisted_11 = {
  class: "py-2",
  style: {"border-bottom":"1px solid #A0AEC0"}
}
const _hoisted_12 = { class: "color-dark text-base font-extrabold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "my-no-more" }, null, -1)
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "vehicle",
  class: "label-text required"
}, "Kendaraan/Bus", -1)
const _hoisted_16 = {
  class: "py-2",
  style: {"border-bottom":"1px solid #A0AEC0"}
}
const _hoisted_17 = { class: "color-dark text-base font-extrabold" }
const _hoisted_18 = {
  key: 0,
  class: "flex items-center mt-2"
}
const _hoisted_19 = {
  key: 0,
  class: "text-grey-5 text-xs"
}
const _hoisted_20 = {
  key: 1,
  class: "text-grey-5 text-xs"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "my-no-more" }, null, -1)
const _hoisted_22 = { class: "invalid-feedback" }
const _hoisted_23 = { class: "grid grid-cols-1" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "text-xl font-bold self-baseline" }
const _hoisted_26 = {
  key: 0,
  class: "flex items-center mb-1"
}
const _hoisted_27 = {
  class: "text-sm",
  style: {"color":"#546E7A"}
}
const _hoisted_28 = { class: "grid grid-cols-4 gap-2" }
const _hoisted_29 = { class: "flex flex-wrap-reverse items-center gap-2 col-span-2" }
const _hoisted_30 = {
  class: "background-grey-2 rounded px-12px py-4px text-xs color-blue-grey-darken-1",
  style: {"border":"1px solid #607D8B"}
}
const _hoisted_31 = {
  class: "background-grey-2 rounded px-12px py-4px text-xs color-blue-grey-darken-1",
  style: {"border":"1px solid #607D8B"}
}
const _hoisted_32 = {
  class: "background-grey-2 rounded px-12px py-4px text-xs color-blue-grey-darken-1",
  style: {"border":"1px solid #607D8B"}
}
const _hoisted_33 = { class: "flex justify-end col-span-2 gap-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-grey mb-1 text-right" }, "Pengeluaran Rit 1", -1)
const _hoisted_35 = { class: "color-dark text-xs font-semibold text-right" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-grey mb-1 text-right" }, "Pengeluaran Rit 2", -1)
const _hoisted_37 = { class: "color-dark text-xs font-semibold text-right" }
const _hoisted_38 = { class: "mb-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "label-text"
}, "Keterangan", -1)
const _hoisted_40 = { class: "container-btn-action" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Kembali")

import { onMounted, computed, ref, reactive, getCurrentInstance, watch } from 'vue'
import { useStore } from 'vuex'
import * as Yup from 'yup'
import { Form, Field, ErrorMessage } from 'vee-validate'
import { DatePicker } from 'v-calendar'
import vSelect from 'vue-select'
import InputText from 'primevue/inputtext'
import Card from 'primevue/card'
import Button from 'primevue/button'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import { debounce, isNull } from 'lodash'
import moment from 'moment'
import $ from 'jquery'
import IResponse from '@/utils/interfaces/iResponse'
import rgxExp from '@/utils/helpers/regExp'
import { IFormSchedule } from '@/utils/interfaces/iDepartureSchedule'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import { VueEternalLoading, LoadAction } from '@ts-pro/vue-eternal-loading'
import ProgressSpinner from 'primevue/progressspinner'
import FormTerminalVue from '../../master-setting/city-terminal/components/FormTerminal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleForm',
  setup(__props) {

const moduleStore = 'hjpDataList'
const endpoint = '/management/v1/MsSchedule'
const endpointUser = '/management/v1/User/all-user'
const endpointTrayek = '/management/v1/Trayek'

const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const store = useStore()
const modalForm = computed(() => store.state[moduleStore].modalForm) as any
const isCopy = computed(() => store.state[moduleStore].modalForm?.data?.isCopy)
const id = computed(() => store.state[moduleStore].modalForm?.data?.Id)
const dataForm = ref<any>(null)
const optionConductor = ref<any[]>([])
const optionVehicle = ref<any[]>([])
const detailVehicle = ref<any>(null)
const isLoading = ref<boolean>(true)
const titleForm = ref<string>('Tambah Jadwal')
const conductorTemp = ref(null) as any
const currStartDate = ref(null) as any
const currEndDate = ref(null) as any
const tempLengthOfConductorList = ref(0)
const pageNumberConductor = ref(1)
const isInitialConductor = ref(false)/** variable yang digunakan untuk mereset state menggunakan plugin vue-eternal-loading */
const stopLoadConductor = ref(false)
const isValidConductor = ref(true)

const tempLengthOfTrayekList = ref(0)
const tempTempLengthOfTrayekList = ref(0)
const pageNumberTrayek = ref(1)
const isInitialTrayek = ref(false)/** variable yang digunakan untuk mereset state menggunakan plugin vue-eternal-loading */
const stopLoadTrayek = ref(false)

const modalConfirmation = reactive({
  show: false,
  imgContent: require('@/assets/img/modal-confirmation/schedule.svg'),
  title: '',
  subTitle: 'Pastikan jadwal yang Anda tambahkan sudah sesuai dan tidak ada perubahan ditengah-tengah.',
  btnSubmitTitle: 'Simpan Perubahan',
})

let formValues = reactive<IFormSchedule>({
  Code: '',
  StartDate: moment().toDate(),
  EndDate: moment().add(2, 'day').toDate(),
  Conductor: null,
  Vehicle: null,
  Description: null
})

const shemaValidation = Yup.object().shape({
  Code: Yup.string()
    .required('Nama Penjadwalan tidak boleh kosong')
    .max(30, 'Nama Penjadwalan maksimal 30 karakter')
    .matches(rgxExp.notSpaceChar, 'Nama Penjadwalan tidak boleh menggunakan spasi')
    .test('unique-code ', 'Nama Penjadwalan sudah digunakan', async (val) => {
      if (!val) return true
      console.log('form', formValues)
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['code'],
          custom: [['startDate', '=', currStartDate.value], ['endDate', '=', currEndDate.value]]
        })}`)
        const filterResult = res.result.filter((x: any) => x.Name === val)
        if (id.value && !isCopy.value) {
          return filterResult.length === 0 || val === formValues.Code
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  // StartDate: Yup.string().required('Tanggal Awal tidak boleh kosong'),
  StartDate: Yup.string().required('Tanggal Awal tidak boleh kosong')
    .test('check-available', 'Kondektur sudah digunakan pada jadwal lain di tanggal ini', async (val) => {
      currStartDate.value = moment(val).format('YYYY-MM-DD')
      console.log('currStartDate', currStartDate.value)
      if (!conductorTemp.value) return true
      try {
        const res = await apiUseCase.postOrPut(`${endpoint}/check-user-available`, null, {
          label: 'start',
          StartDate: moment(val).format('YYYY-MM-DD'),
          EndDate: moment(id.value ? val : currEndDate.value).format('YYYY-MM-DD'),
          UserId: conductorTemp.value
        })
        // console.log('res', res)
        isValidConductor.value = !res.error
        return !res.error || moment(formValues.StartDate).format('YYYY-MM-DD') === moment(val).format('YYYY-MM-DD')
      } catch (error) {
        return false
      }
    }),
  EndDate: Yup.string().required('Tanggal Akhir tidak boleh kosong')
    .test('check-available', 'Kondektur sudah digunakan pada jadwal lain di tanggal ini', async (val) => {
      if (!conductorTemp.value) return true
      currEndDate.value = moment(val).format('YYYY-MM-DD')
      console.log('currStartDate', currStartDate.value)
      try {
        const res = await apiUseCase.postOrPut(`${endpoint}/check-user-available`, null, {
          label: 'end',
          StartDate: moment(currStartDate.value).format('YYYY-MM-DD'),
          EndDate: moment(id.value ? currStartDate.value : val).format('YYYY-MM-DD'),
          UserId: conductorTemp.value
        })
        isValidConductor.value = !res.error
        // console.log('res', res)
        return !res.error || moment(formValues.EndDate).format('YYYY-MM-DD') === moment(val).format('YYYY-MM-DD')
      } catch (error) {
        return false
      }
    }),
  Conductor: Yup.object().nullable()
    .when(['StartDate', 'EndDate'], ([StartDate, EndDate], schema) => {
      const afterCheck = schema.test('check-available', 'Kondektur sudah digunakan pada jadwal lain.', async (val: any) => {
        if (!val) return true
        conductorTemp.value = val.value
        try {
          if (!isNull(StartDate) && !isNull(EndDate)) {
            const { error } = await apiUseCase.postOrPut(`${endpoint}/check-user-available`, null, {
              label: 'conductor',
              StartDate: moment(StartDate).format('YYYY-MM-DD'),
              EndDate: id.value ? moment(StartDate).format('YYYY-MM-DD') : moment(EndDate).format('YYYY-MM-DD'),
              UserId: val.value
            })
            if (id.value && !isCopy.value) {
              return !error || formValues.Conductor.value === val.value
            }
            isValidConductor.value = !error
            return !error
          } return false
        } catch (error) {
          return false
        }
      })
      return afterCheck
    }),
  Vehicle: Yup.object().required('Kendaraan/Bus tidak boleh kosong')
    .when(['StartDate', 'EndDate'], ([StartDate, EndDate], schema) => {
      const afterCheck = schema.test('check-available', 'Kendaraan/Bus sudah digunakan pada jadwal lain.', async (val: any) => {
        try {
          if (!isNull(StartDate) && !isNull(EndDate)) {
            const { error } = await apiUseCase.postOrPut(`${endpoint}/check-vehicle-available`, null, {
              label: 'vehicle',
              StartDate: moment(StartDate).format('YYYY-MM-DD'),
              EndDate: id.value ? moment(StartDate).format('YYYY-MM-DD') : moment(EndDate).format('YYYY-MM-DD'),
              VehicleId: val.value
            })
            if (id.value && !isCopy.value) {
              return !error || formValues.Vehicle.value === val.value
            }
            return !error
          } return false
        } catch (error) {
          return false
        }
      })
      return afterCheck
    })
})

const onSubmit = (val: any) => {
  console.log('val', val)
  dataForm.value = val
  modalConfirmation.show = true
}
const hideSidebar = () => {
  store.dispatch('setShowModalFormDl', false)
}

const getConductor = async (search: string | null = null) => {
  await apiUseCase.get(`${endpointUser}${returnUrlPrams({
    search,
    filterField: ['nama'],
    custom: [['roles', '=', 'Condectur'], ['activeOnly', '=', true], ['pageNumber', '=', pageNumberConductor.value]]
  })}`).then((res) => {
    tempLengthOfConductorList.value = res.result.length
    const optionConductorTemp = res.result.map((val: any) => ({
      ...val,
      label: `${val.Fullname}`,
      value: val.Id,
      selectable: true
    }))
    optionConductorTemp.forEach((x: any) => optionConductor.value.push(x))
  })
}

/* eslint-disable arrow-body-style */
const getBus = (search: string | null = null): Promise<any> => {
  console.log('search', search)
  return apiUseCase.get(`${endpointTrayek}${returnUrlPrams({
    search,
    filterField: ['regnumber'],
    custom: [['activeOnly', '=', true], ['hasVehicle', '=', true], ['pageNumber', '=', stopLoadTrayek.value ? 1 : pageNumberTrayek.value]]
  })}`).then((res) => {
    console.log('res', res)
    // tempLengthOfTrayekList.value = res.result.length
    if (!res.error) {
      let mapResponse = null as any
      if (search) {
        const mapResponseFilter = res.result.filter((v: any) => v.ActiveRegNumber === search)
        mapResponse = mapResponseFilter.map((val: any) => {
          const routes = val.Routes ?? []
          return {
            ...val,
            label: `${val.ParentTrayekId ? val.ActiveRegNumber : val.Nopol}`,
            value: val.ParentTrayekId ? val.ConnectedActiveVehicleId : val.MsVehicleId,
            destinationCity: `${routes[0]?.MsStation?.CityName} - ${routes[routes.length - 1]?.MsStation?.CityName}`,
          }
        })
      } else {
        mapResponse = res.result.map((val: any) => {
          const routes = val.Routes ?? []
          return {
            ...val,
            label: `${val.ParentTrayekId ? val.ActiveRegNumber : val.Nopol}`,
            value: val.ParentTrayekId ? val.ConnectedActiveVehicleId : val.MsVehicleId,
            destinationCity: `${routes[0]?.MsStation?.CityName} - ${routes[routes.length - 1]?.MsStation?.CityName}`,
          }
        })
      }
      console.log('mapResponse', mapResponse)
      return mapResponse
    }
    return null
  })
}

const getOptionBus = async (search: string | null = null) => {
  const response = await getBus(search)
  console.log('responseOption', response.length)
  tempLengthOfTrayekList.value = response.length
  // optionVehicle.value = response
  response.forEach((x: any) => optionVehicle.value.push(x))
  console.log('optionVehicle', optionVehicle.value)
}

const getDetailVehicle = async (key: string) => {
  const response = await getBus(key)
  console.log('key', [key, response])
  const filterList = response.filter((v: any) => v.ActiveRegNumber === key)
  console.log('filter', filterList)
  detailVehicle.value = filterList[0]
  console.log('detailVehicle', detailVehicle.value)
}
const onSearchConductor = debounce(getConductor, 500)
const onSearchVehicle = debounce(getOptionBus, 500)

const getDetailForm = (): void => {
  apiUseCase.get(`${endpoint}/single/${id.value}`).then(({ error, result }: IResponse) => {
    if (!error) {
      console.log('result', result)
      getDetailVehicle(result.Vehicle.ActiveRegNumber === '' ? result.Vehicle.Nopol : result.Vehicle.ActiveRegNumber)
      let Vehicle = null
      let Conductor = null
      if (result.User) {
        Conductor = {
          label: result.User.Name,
          value: result.User.Id
        }
        conductorTemp.value = result.User.Id
      }
      if (result.Vehicle) {
        Vehicle = {
          label: result.Vehicle.ActiveRegNumber === '' ? result.Vehicle.Nopol : result.Vehicle.ActiveRegNumber,
          value: result.Vehicle.ConnectedActiveVehicleId === '' ? result.Vehicle.Id : result.Vehicle.ConnectedActiveVehicleId
        }
      }
      const mapDataForm = {
        ...result,
        Vehicle,
        Conductor
      }
      console.log('mapData', mapDataForm)
      if (isCopy.value) {
        mapDataForm.Code = `${result.Code}_COPY`
      }
      formValues = mapDataForm
      console.log('formValues', formValues)
      isLoading.value = false
    }
  })
}

const checkAddOrUpdate = () => {
  modalConfirmation.title = 'Simpan Jadwal'
  titleForm.value = 'Tambah Jadwal'
  if (modalForm.value.data) {
    console.log('update')
    modalConfirmation.title = 'Simpan Perubahan Jadwal'
    titleForm.value = 'Edit Jadwal'
    getDetailForm()
  } else {
    isLoading.value = false
  }
  if (isCopy.value) {
    titleForm.value = 'Copy Jadwal'
    $('.wrap-ic-del').css({
      visibility: 'hidden'
    })
  }
  store.dispatch('setTitleFormSidebarDl', `${titleForm.value}`)
}

const hideModalConfirmation = () => {
  modalConfirmation.show = false
}

const doSubmitConfirm = () => {
  store.dispatch('showLoading')
  const payload = {
    Code: dataForm.value.Code,
    StartDate: moment(dataForm.value.StartDate).format('YYYY-MM-DD'),
    EndDate: moment(id.value ? dataForm.value.StartDate : dataForm.value.EndDate).format('YYYY-MM-DD'),
    MsVehicleId: dataForm.value.Vehicle.value,
    MsTrayekId: dataForm.value.Vehicle.Id,
    IdUser: isNull(dataForm.value.Conductor) ? null : dataForm.value.Conductor.value,
    description: dataForm.value.Description,
    IsActive: true
  }
  const idPrams = isCopy.value ? null : id.value ?? null
  apiUseCase.postOrPut(endpoint, idPrams, payload)
    .then(({ error }) => {
      if (!error) {
        hideModalConfirmation()
        store.dispatch('setReloadDataList', true)
        store.dispatch('setShowModalFormDl', false)
        $toast.add({
          severity: 'success',
          detail: 'Jadwal berhasil ditambahkan',
          group: 'bc',
          closable: false,
          life: 3000
        })
      } else {
        store.dispatch('setShowModalFormDl', false)
        $toast.add({
          severity: 'error',
          detail: 'Jadwal gagal ditambahkan',
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
      store.dispatch('hideLoading')
    })
}

watch(() => isLoading.value, (val) => {
  if (val) {
    store.dispatch('showLoading')
  } else {
    store.dispatch('hideLoading')
  }
})

const loadDataConductor = async ({ loaded, noMore }: LoadAction) => {
  console.log('aaa', tempLengthOfConductorList.value)
  if (tempLengthOfConductorList.value >= 10 && !stopLoadConductor.value) {
    pageNumberConductor.value += 1
    getConductor().then((x: any) => {
      if (tempLengthOfConductorList.value < 10) {
        console.log('<10', tempLengthOfConductorList.value)
        stopLoadConductor.value = true
        /** menggunakan fungsi unutuk mereset state data kosong type dri interface plugin vue-eternal-loading */
        noMore()
      } else {
        console.log('xxx')
        /** menggunakan fungsi unutuk load state type dri interface plugin vue-eternal-loading */
        loaded()
      }
    })
  } else {
    noMore()
  }
}

const loadDataTrayek = async ({ loaded, noMore }: LoadAction) => {
  console.log('aaa', tempLengthOfTrayekList.value)
  if (tempLengthOfTrayekList.value >= 10 && !stopLoadTrayek.value) {
    pageNumberTrayek.value += 1
    getOptionBus().then((x: any) => {
      if (tempLengthOfTrayekList.value < 10) {
        console.log('<10', tempLengthOfTrayekList.value)
        stopLoadTrayek.value = true
        /** menggunakan fungsi unutuk mereset state data kosong type dri interface plugin vue-eternal-loading */
        noMore()
      } else {
        console.log('xxx')
        /** menggunakan fungsi unutuk load state type dri interface plugin vue-eternal-loading */
        loaded()
      }
    })
  } else {
    noMore()
  }
}

onMounted(() => {
  currStartDate.value = moment(formValues.StartDate).format('YYYY-MM-DD')
  currEndDate.value = moment(formValues.EndDate).format('YYYY-MM-DD')
  // console.log('id', id.value ? true : false)
  getOptionBus()
  getConductor()
  checkAddOrUpdate()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!isLoading.value)
      ? (_openBlock(), _createBlock(_unref(Form), {
          key: 0,
          onSubmit: onSubmit,
          "validation-schema": _unref(shemaValidation),
          "initial-values": _unref(formValues),
          class: "form-container",
          validateOnMount: true
        }, {
          default: _withCtx(({ errors, values, setFieldValue }) => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_unref(Field), {
                id: "code",
                name: "Code"
              }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_unref(InputText), _mergeProps(field, {
                    modelValue: values.Code,
                    "onUpdate:modelValue": ($event: any) => ((values.Code) = $event),
                    onChange: handleChange,
                    onBlur: handleBlur,
                    class: `input-primary ${errors.Code ? 'input-invalid' : ''}`,
                    placeholder: "Nama Penjadwalan",
                    readonly: _unref(isCopy),
                    autocomplete: "off"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class", "readonly"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_3, _toDisplayString(errors.Code), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_unref(id) ? 'mb-4' : 'grid grid-cols-2 gap-4 mb-4')
            }, [
              _createElementVNode("div", null, [
                _hoisted_4,
                _createVNode(_unref(Field), { name: "StartDate" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_unref(DatePicker), _mergeProps({
                      modelValue: values.StartDate,
                      "onUpdate:modelValue": ($event: any) => ((values.StartDate) = $event)
                    }, field, {
                      "onUpdate:modelValue": (val) => {
              if (_unref(moment)(val) > _unref(moment)(values.EndDate)) {
                setFieldValue('EndDate', val)
              }
              setFieldValue('StartDate', val)
            },
                      masks: { input: 'DD/MM/YYYY' },
                      "min-date": _unref(moment)().toDate()
                    }), {
                      default: _withCtx(({ togglePopover, inputValue }) => [
                        _createVNode(_unref(InputText), {
                          id: "start-date",
                          "aria-describedby": "start-date-help",
                          placeholder: "DD/MM/YYYY",
                          value: inputValue,
                          class: _normalizeClass(`input-primary ${errors.StartDate ? 'input-invalid' : ''}`),
                          onClick: togglePopover,
                          readonly: ""
                        }, null, 8, ["value", "class", "onClick"])
                      ]),
                      _: 2
                    }, 1040, ["modelValue", "onUpdate:modelValue", "min-date"])
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_5, _toDisplayString(errors.StartDate), 1)
              ]),
              (!_unref(id))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_unref(Field), { name: "EndDate" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_unref(DatePicker), _mergeProps({
                          modelValue: values.EndDate,
                          "onUpdate:modelValue": ($event: any) => ((values.EndDate) = $event)
                        }, field, {
                          "onUpdate:modelValue": (val) => setFieldValue('EndDate', val),
                          masks: {
                input: 'DD/MM/YYYY'
              },
                          "min-date": values.StartDate
                        }), {
                          default: _withCtx(({ togglePopover, inputValue }) => [
                            _createVNode(_unref(InputText), {
                              id: "end-date",
                              "aria-describedby": "end-date-help",
                              placeholder: "DD/MM/YYYY",
                              value: inputValue,
                              class: _normalizeClass(`input-primary ${errors.EndDate ? 'input-invalid' : ''}`),
                              onClick: togglePopover,
                              readonly: ""
                            }, null, 8, ["value", "class", "onClick"])
                          ]),
                          _: 2
                        }, 1040, ["modelValue", "onUpdate:modelValue", "min-date"])
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(errors.EndDate), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_unref(Field), {
                id: "conductor",
                name: "Conductor"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(vSelect), {
                    autofocus: false,
                    class: _normalizeClass(`select-primary ${errors.Conductor ? 'select-invalid' : ''}`),
                    modelValue: values.Conductor,
                    "onUpdate:modelValue": ($event: any) => ((values.Conductor) = $event),
                    options: optionConductor.value,
                    "onOption:selecting": (val) => {
              setFieldValue('Conductor', val)
            },
                    placeholder: "Pilih Kondektur",
                    clearable: false,
                    "onSearch:blur":  field.onBlur,
                    onSearch: _unref(onSearchConductor)
                  }, {
                    option: _withCtx((data ) => [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("p", _hoisted_12, _toDisplayString(data.label), 1)
                      ]),
                      _createVNode(_unref(VueEternalLoading), {
                        load: loadDataConductor,
                        "is-initial": isInitialConductor.value,
                        "onUpdate:is-initial": _cache[0] || (_cache[0] = ($event: any) => ((isInitialConductor).value = $event)),
                        class: "flex justify-center"
                      }, {
                        loading: _withCtx(() => [
                          _createVNode(_unref(ProgressSpinner), {
                            class: "h-2",
                            strokeWidth: "5"
                          })
                        ]),
                        "no-more": _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }, 8, ["is-initial"])
                    ]),
                    _: 2
                  }, 1032, ["class", "modelValue", "onUpdate:modelValue", "options", "onOption:selecting", "onSearch:blur", "onSearch"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(ErrorMessage), {
                class: "invalid-feedback",
                name: "Conductor"
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_unref(Field), {
                id: "vehicle",
                name: "Vehicle"
              }, {
                default: _withCtx(( { field } ) => [
                  _createVNode(_unref(vSelect), {
                    autofocus:  false ,
                    class: _normalizeClass( `select-primary ${errors.Vehicle ? 'select-invalid' : ''}` ),
                    modelValue:  values.Vehicle ,
                    "onUpdate:modelValue": ($event: any) => (( values.Vehicle ) = $event),
                    options:  optionVehicle.value ,
                    "onOption:selecting": 
              (val) => {
                setFieldValue('Vehicle', val)
                getDetailVehicle(val.label)
              }
            ,
                    placeholder: "Pilih Kendaraan",
                    clearable:  false ,
                    "onSearch:blur":  field.onBlur,
                    onSearch:  _unref(onSearchVehicle) 
                  }, {
                    option: _withCtx(( data ) => [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(data.label), 1),
                        ( data.Station )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              (data.SecondRitName)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(data.FirstRitName) + " - " + _toDisplayString(data.SecondRitName), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(data.FirstRitName), 1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_unref(VueEternalLoading), {
                        load: loadDataTrayek,
                        "is-initial": isInitialTrayek.value,
                        "onUpdate:is-initial": _cache[1] || (_cache[1] = ($event: any) => ((isInitialTrayek).value = $event)),
                        class: "flex justify-center"
                      }, {
                        loading: _withCtx(() => [
                          _createVNode(_unref(ProgressSpinner), {
                            class: "h-2",
                            strokeWidth: "5"
                          })
                        ]),
                        "no-more": _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }, 8, ["is-initial"])
                    ]),
                    _: 2
                  }, 1032, ["class", "modelValue", "onUpdate:modelValue", "options", "onOption:selecting", "onSearch:blur", "onSearch"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_22, _toDisplayString(errors.Vehicle), 1),
              ( detailVehicle.value )
                ? (_openBlock(), _createBlock(_unref(Card), {
                    key: 0,
                    class: "card-no-shadow mt-1"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("p", _hoisted_25, _toDisplayString(detailVehicle.value.Name), 1),
                          ( detailVehicle.value.Routes?.length > 0 )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("p", _hoisted_27, _toDisplayString(detailVehicle.value.Station.FirstCity) + " - " + _toDisplayString(detailVehicle.value.Station.LastCity), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, _toDisplayString(detailVehicle.value.ActiveRegNumber), 1),
                              _createElementVNode("div", _hoisted_31, _toDisplayString(detailVehicle.value.Status), 1),
                              _createElementVNode("div", _hoisted_32, _toDisplayString(detailVehicle.value.Station?.RouteCount) + " Terminal", 1)
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", null, [
                                _hoisted_34,
                                _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(rupiahFormat)(detailVehicle.value.FirstExpenseNominal)), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_36,
                                _createElementVNode("p", _hoisted_37, _toDisplayString(_unref(rupiahFormat)(detailVehicle.value.SecondExpenseNominal)), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createVNode(_unref(Field), {
                id: "description",
                name: "Description",
                as: "textarea",
                class: "input-primary",
                placeholder: "Tulis keterangan"
              })
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_unref(Button), {
                class: "btn-back mr-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (hideSidebar()))
              }, {
                default: _withCtx(() => [
                  _hoisted_41
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                class: "btn-primary mr-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(titleForm.value), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["validation-schema", "initial-values"]))
      : _createCommentVNode("", true),
    _createVNode(HjpConfirmationModal, {
      show:  modalConfirmation.show ,
      imgContent:  modalConfirmation.imgContent ,
      title:  modalConfirmation.title ,
      subTitle:  modalConfirmation.subTitle ,
      btnSubmitTitle:  modalConfirmation.btnSubmitTitle ,
      onHideDialog:  hideModalConfirmation ,
      onOnSubmit:  doSubmitConfirm 
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"])
  ]))
}
}

})